import { isCircleAiOnboardingSettingEnabled } from "@circle-react/components/CircleAi/useCircleAiFeatureFlags";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import type { CommunitySettings } from "@circle-react/types/CommunitySettings";
import type { ExperimentationFlags } from "@circle-react/types/ExperimentationFlags";

import { usePunditUserContext } from "@/react/contexts/punditUserContext";

interface CircleAiOnboardingEnabledParams {
  currentCommunitySettings?: Pick<
    CommunitySettings,
    "circle_ai_onboarding_enabled"
  >;
  experimentationFlags?: ExperimentationFlags;
  isCircleV4?: boolean;
}

export const isCircleAiOnboardingEnabled = ({
  currentCommunitySettings,
  experimentationFlags,
  isCircleV4,
}: CircleAiOnboardingEnabledParams): boolean =>
  !!isCircleV4 ||
  isCircleAiOnboardingSettingEnabled(currentCommunitySettings) ||
  experimentationFlags?.["circle_ai_onboarding_test"] === true;

export const useIsCircleAiOnboardingEnabled = (): boolean => {
  const { currentCommunitySettings, experimentation } = usePunditUserContext();
  const { isCircleV4 } = useCircleV4();
  return isCircleAiOnboardingEnabled({
    currentCommunitySettings,
    experimentationFlags: experimentation.flags,
    isCircleV4,
  });
};
